import React from "react";

interface HubfloBannerProps {
  className?: string;
  showAnimation?: boolean;
  height?: number;
}

const HubfloBanner: React.FC<HubfloBannerProps> = ({ 
  className = "", 
  showAnimation = true,
  height = 280
}) => {
  return (
    <div className={`w-full ${className}`}>
      <div 
        className="bg-gradient-to-t from-amber-100 via-amber-50 to-white p-6 pb-0 flex flex-col justify-between overflow-hidden relative"
        style={{ height: `${height}px` }}
      >
        <div className="absolute -left-16 -top-16 w-32 h-32 bg-gradient-to-t from-yellow-400 to-amber-300 rounded-full opacity-20 blur-2xl"></div>
        <div className="absolute -right-16 -bottom-16 w-32 h-32 bg-gradient-to-t from-amber-400 to-yellow-300 rounded-full opacity-20 blur-2xl"></div>
        
        {/* WhatsApp-style Background Pattern Overlay */}
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: `url(${import.meta.env.VITE_SUPABASE_URL}/storage/v1/object/public/image_library/chat_backgrounds/Whatsapp-Style-Background.svg)`,
            backgroundSize: 'cover',
            backgroundPosition: 'center center',
            backgroundRepeat: 'no-repeat',
            opacity: 0.06,
            zIndex: 1,
            pointerEvents: 'none',
            filter: 'sepia(0.3) saturate(0.8) hue-rotate(20deg)',
          }}
        />
        
        <div className="flex justify-center relative z-10">
          <img 
            src={`${import.meta.env.VITE_SUPABASE_URL}/storage/v1/object/public/image_library/public_images/hubflo%20agents%20horizontal%20dark.svg`} 
            alt="Hubflo Agents Logo" 
            className="h-[50px] w-auto" 
          />
        </div>
        
        {showAnimation && (
          <div className="flex justify-center mt-4 relative z-10">
            <img 
              src={`${import.meta.env.VITE_SUPABASE_URL}/storage/v1/object/public/image_library/public_images/2%20agents%20animation%20gif.gif`} 
              alt="Hubflo Agents" 
              className="w-[95%] max-w-[320px] h-auto mt-4" 
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default HubfloBanner; 